<!-- <div  class="example-header">
    <mat-form-field floatLabel="never" cdkFocusInitial>
        <input matInput (keyup)="applyFilter($event.target)" placeholder="Search">
    </mat-form-field>
</div> -->



<div class="example-container  mat-elevation-z0 matPaginationCustom">
    <!-- <mat-table #table matSort [dataSource]="dataSource" [style.max-height]="maxHeight" > -->
    <mat-table #table matSort [dataSource]="dataSource">
        <!-- <ng-container *ngIf="(isClickable)" [matColumnDef]="'actions'">
            <mat-header-cell *matHeaderCellDef></mat-header-cell>
            <ng-container *ngIf="singleRowSelect">
                <mat-cell *matCellDef="let row">
                    <mat-radio-button (click)="clicked(row)"></mat-radio-button>
                </mat-cell>
            </ng-container>
            <ng-container *ngIf="!singleRowSelect">
                <mat-cell *matCellDef="let row">
                    <mat-checkbox (change)="checkBox($event,row)"></mat-checkbox>
                </mat-cell>
            </ng-container>
        </ng-container> -->
    
        <ng-container *ngIf="editEnable" [matColumnDef]="'actions'">
            <mat-header-cell *matHeaderCellDef>
            </mat-header-cell>
            <mat-cell *matCellDef="let row" class="d-flex justify-content-center">
                <div class="editDeleteWrapper d-flex justify-content-center">
                    <div (click)="clickEditorDelete(row,editKeyText)" class="pointers">
                        <i class="fa fa-edit edit_text_color"></i>
                    </div>
                   
                
                </div>
            </mat-cell>
        </ng-container>


        <ng-container *ngIf="editDeleteEnable" [matColumnDef]="'actions'">
            <mat-header-cell *matHeaderCellDef>
            </mat-header-cell>
            <mat-cell *matCellDef="let row" class="d-flex justify-content-center">
                <div class="editDeleteWrapper d-flex justify-content-center">
                    <div (click)="clickEditorDelete(row,editKeyText)" class="pointers">
                        <i class="fa fa-edit edit_text_color"></i>
                    </div>
                    &nbsp;&nbsp;&nbsp;&nbsp;
                    <div (click)="clickEditorDelete(row,deleteKeyText)" class="pointers" >
                        <i class="fa fa-trash text-danger"></i>
                    </div>
                    &nbsp;&nbsp;&nbsp;&nbsp;
                    <div (click)="clickEditorDelete(row,viewKeyText)" class="pointers">
                        <i class="fa fa-chevron-right view_text_color"></i>
                    </div>
                </div>
            </mat-cell>
        </ng-container>


        <ng-container [matColumnDef]="col.labelValue" *ngFor="let col of tableHead;let i=index;" [sticky]="(i< stickyValue)">
            <ng-container *ngIf="(sorting)">
                <mat-header-cell *matHeaderCellDef mat-sort-header> {{ col.labelValue }} </mat-header-cell>
            </ng-container>

            <ng-container *ngIf="(!sorting)">
                <mat-header-cell *matHeaderCellDef> {{ col.labelValue }} </mat-header-cell>
            </ng-container>
            <!-- ///////////////////////////////// -->
            <ng-container>
                <ng-container>
                    <!-- <mat-cell *matCellDef="let element">{{ element[col.dataId] }}</mat-cell> -->
                    <mat-cell *matCellDef="let element">
                        <div>
                            <ng-container *ngIf="!element[col.dataId+'Color']">{{ element[col.dataId] }}</ng-container>
                        </div>
                      <div>
                        <ng-container *ngIf="element[col.dataId+'PercentChange']">
                            <span *ngIf="element[col.dataId+'PercentChange']?.color=='green'" class="arrowUpTable"></span>
                            <span *ngIf="element[col.dataId+'PercentChange']?.color=='red'" class="arrowDownTable"></span>
                            <span>{{element[col.dataId+'PercentChange']['percent']}}</span>
                        </ng-container>
                      </div>  
                        <!-- <span *ngIf="element[col.dataId+'Color']" [style.color]="element[col.dataId+'Color']"
                            [style.border-color]="element[col.dataId+'Color']" style="text-align:center;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{
                            element[col.dataId] }}</span> -->
                    </mat-cell>
                </ng-container>
            </ng-container>
        
        </ng-container>

        <mat-header-row *matHeaderRowDef="columnIds;sticky:true;"></mat-header-row>
        <!-- <mat-row *matRowDef="let row; columns: columnIds;" (click)="getRecord(row)"></mat-row> -->
        <mat-row *matRowDef="let row; columns: columnIds;"></mat-row>
    </mat-table>

    
    <mat-paginator *ngIf="pagination" [pageSizeOptions]="pageSizeOptions" showFirstLastButtons></mat-paginator>
</div>